import React, { useEffect, useState } from 'react';
import { forwardToNewDesign } from "../../utils/forwardToNewDesign";
import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
import { postRequest } from '../../services/api/apiService';
import { getAuthToken } from '../../utils/auth';
import { afterPlatformConnect } from "../../utils/afterPlatformConnect";

const GoogleAdsCallback = () => {
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (forwardToNewDesign()) return; // tunnel lancé depuis un autre client OneBotAds
    // Extract the authorization code from the query string
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const error = urlParams.get('error');

    if (error) {
      // If there's an error, redirect to error page
      setError('Google Ads authentication failed.');
      navigate('/error');
    } else if (code) {

        const token = getAuthToken();

        console.log("token: ", token)
        
      // Send the authorization code to the backend
        postRequest('/api/ads-auth/google/callback', {code}, {Authorization: `Bearer ${token}`
        })
        .then(response => {
          // Handle successful response
          if (response.success) {
            // If everything is successful, redirect to dashboard
            navigate(afterPlatformConnect());
          } else {
            // If there's an error, redirect to error page
            setError('Failed to save Google Ads account details.');
            navigate('/error');
          }
        })
        .catch(error => {
          setError('Error during the Google Ads authentication process.');
          navigate('/error');
        });
    }
  }, [navigate]);

  return (
    <div>
      {error && <p>{error}</p>}
    </div>
  );
};

export default GoogleAdsCallback;